import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modalpopup" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "font-weight-600 margin-left-20" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "merge-modal-hr-top"
}
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  key: 0,
  class: "margin-bottom-10"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["placeholder", "maxlength"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "table-wrap" }
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "table-header" }
const _hoisted_17 = { class: "header-row" }
const _hoisted_18 = { class: "header-cell" }
const _hoisted_19 = { class: "header-cell" }
const _hoisted_20 = { class: "table-body" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "table-data selected-cell" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "table-data name-cell" }
const _hoisted_25 = { class: "template-name" }
const _hoisted_26 = { class: "table-data text-right margin-right-25" }
const _hoisted_27 = { class: "margin-top-10" }
const _hoisted_28 = { class: "text-center margin-top-40" }
const _hoisted_29 = { class: "modal-optional-label" }
const _hoisted_30 = {
  key: 3,
  class: "description-block"
}
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 1,
  class: "merge-modal-hr-bottom"
}
const _hoisted_33 = { class: "modal-footer" }
const _hoisted_34 = ["hidden"]
const _hoisted_35 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.localModalPopUp.Heading ?? ''), 1),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "cross-icon",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Cancel()))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.crossIcon,
                      alt: "cross"
                    }, null, 8, _hoisted_7)
                  ])
                ]),
                (_ctx.localModalPopUp.ModelDescription)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isValidationSummaryVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.isValidationSummaryVisible)
                          ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                              key: 0,
                              "error-fields": _ctx.validationErrorFields,
                              onCloseClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                            }, null, 8, ["error-fields"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isTableViewOn && !_ctx.localModalPopUp.ModelDescription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.localInput.$model) = $event)),
                          class: "form-control",
                          placeholder: _ctx.localModalPopUp.Placeholder,
                          maxlength: _ctx.maxTemplateNameLength
                        }, null, 8, _hoisted_12), [
                          [
                            _vModelText,
                            _ctx.v$.localInput.$model,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isTableViewOn && !_ctx.localModalPopUp.ModelDescription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header-cell selected-cell" }, null, -1)),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.TemplatesName')), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.LastUpdatedOnHeading')), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customTemplates, (row) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: row.Id,
                                  class: _normalizeClass(["table-row", { selected: _ctx.selectedIndex === row.Id }]),
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.SelectRow(row.Id, row))
                                }, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("img", {
                                      src: _ctx.tickIcon,
                                      alt: "tickIcon",
                                      class: "blue-tick"
                                    }, null, 8, _hoisted_23)
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(row.TemplateName ?? ''), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.FormatDate(row.ModifiedOn)), 1)
                                  ])
                                ], 10, _hoisted_21))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('Or').toString()), 1),
                            _createElementVNode("a", {
                              class: "modal-optional-link",
                              href: "javascript:void(0)",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ToggleToInputMode && _ctx.ToggleToInputMode(...args)))
                            }, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.ModalLink.SaveAsNewTemplate').toString()), 1)
                          ])
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "modal-hr" }, null, -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.localModalPopUp.ModelDescription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.HandleTagClick && _ctx.HandleTagClick(...args))),
                          innerHTML: _ctx.localModalPopUp.ModelDescription
                        }, null, 8, _hoisted_31)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.localModalPopUp.ModelDescription)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_32))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    class: "button-cancel",
                    hidden: !_ctx.localModalPopUp.ShowButton1,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.Cancel()))
                  }, _toDisplayString(_ctx.localModalPopUp.Button1Text || ''), 9, _hoisted_34),
                  _createElementVNode("button", {
                    hidden: _ctx.localModalPopUp.Button2Text.length === 0,
                    class: "button-save",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.Submit(_ctx.v$)))
                  }, _toDisplayString(_ctx.localModalPopUp.Button2Text || ''), 9, _hoisted_35)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}